export const selectRecommendations = state => state.recommendations;

export const selectCountRecommendations = state => state.recommendations.length;
